import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify';
import Rollbar from 'rollbar';
import '@/plugins/dayjs'

Vue.config.productionTip = false

Vue.prototype.$rollbar = new Rollbar({
  accessToken: 'bbf3f59a8bee4beb9900721183a36e5f',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: 'app-development'
});

Vue.config.errorHandler = (err, vm) => {
  vm.$rollbar.error(err);
  throw err; // rethrow
};

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
